var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"person-facts pl-2 mb-0"},_vm._l((_vm.facts),function(fact,index){return _c('li',{key:index,staticClass:"mb-1"},[_vm._v(" "+_vm._s(fact)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }